import(/* webpackMode: "eager", webpackExports: ["Actions"] */ "/vercel/path0/apps/PublicUI/app/(embeds)/embed/[educator_param]/[course_param]/feature/Actions/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/app/(embeds)/embed/[educator_param]/[course_param]/feature/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/app/(embeds)/embed/[educator_param]/[course_param]/feature/Thumbnail/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/PublicUI/components/CourseTagline/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/components/DeliveryIndicator/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/components/VATLabel/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/app/(embeds)/embed/[educator_param]/[course_param]/feature/CourseTitle/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
